import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';

import {
  UPDATE_ASSETS_START,
} from '../../actions/types'

import {
  updateAssetsSuccess,
  updateAssetsFailure,
} from '../../actions'

import { putLoanApplicationUser } from '../../requesters/loanApplicationUser'

import {
  getLoanApplicationId,
  getAssets,
   } from '../../reducers'

function* loanUpdateAssets(action) {
  const assets = yield select(getAssets);
  const loanApplicationId = yield select(getLoanApplicationId);

  const data = {
    loan_application_user: {
      assets_attributes: assets
    }
  }

  const { response, error } = yield call(putLoanApplicationUser, loanApplicationId, data)

  if (response) {
    yield put(updateAssetsSuccess(response))
  } else {
    yield put(updateAssetsFailure({
      entities: error.response.data.assets,
    }))
  }
}

export function* watchLoanUpdateAssets() {
  yield takeLatest(UPDATE_ASSETS_START, loanUpdateAssets)
}
